// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-traveler-profile-changePassword-changePasswordForm-module__sectionBox--ofhQo {
    background-color: var(--grey1);
    margin-left: -20px;
    margin-right: -20px;
    padding: 20px;
  }
  
  .src-js-traveler-profile-changePassword-changePasswordForm-module__paddingBottom--KN9r4 {
    padding-bottom: 24px;
  }
  
  .src-js-traveler-profile-changePassword-changePasswordForm-module__flexColumnCenter--lpRzd {
    flex-direction: column;
    align-items: center;
  }`, "",{"version":3,"sources":["webpack://./src/js/traveler/profile/changePassword/changePasswordForm.module.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB","sourcesContent":[".sectionBox {\n    background-color: var(--grey1);\n    margin-left: -20px;\n    margin-right: -20px;\n    padding: 20px;\n  }\n  \n  .paddingBottom {\n    padding-bottom: 24px;\n  }\n  \n  .flexColumnCenter {\n    flex-direction: column;\n    align-items: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sectionBox": `src-js-traveler-profile-changePassword-changePasswordForm-module__sectionBox--ofhQo`,
	"paddingBottom": `src-js-traveler-profile-changePassword-changePasswordForm-module__paddingBottom--KN9r4`,
	"flexColumnCenter": `src-js-traveler-profile-changePassword-changePasswordForm-module__flexColumnCenter--lpRzd`
};
export default ___CSS_LOADER_EXPORT___;
